<script>
import toast from '@/methods/toast'
import visualEffects from '@/methods/visualEffects'
export default {
  name: 'DynamicForm',
  props: {
    schema: Object,
    model: Object,
    showForm: Boolean
  },
  data () {
    return {
    }
  },
  methods: {
    seePassword (idName) {
        visualEffects.seePassword(idName)
    },
    validations () {
      for (const key in this.schema.fields) {
        if (this.schema.fields.hasOwnProperty(key)) {
          if (this.schema.fields[key].type === 'group') {
            for (const keyGroup in this.schema.fields[key].data) {
              if (this.schema.fields[key].data.hasOwnProperty(keyGroup)) {
                let objGroup = this.schema.fields[key].data[keyGroup]   
                if (objGroup.required) {
                  if (this.model[objGroup.model] === '' ||
                      this.model[objGroup.model] === null ||
                      this.model[objGroup.model] === undefined) {
                    toast.toastError('Campo ' + objGroup.label + ' deve ser informado antes de gravar!')
                    return false
                  }
                }
              }
            }

          } else {
            if (this.schema.fields[key].required) {
              if (this.model[this.schema.fields[key].model] === '' ||
                  this.model[this.schema.fields[key].model] === null ||
                  this.model[this.schema.fields[key].model] === undefined) {
                toast.toastError('Campo ' + this.schema.fields[key].label + ' deve ser informado antes de gravar!')
                return false
              }
            }
          }
        }
      }
      return true
    },
    sendData (param) {
      if (this.validations()) {
        this.schema.callBackSuccess(param)
        .then(() => {
          this.close()
        })        
      }
    },
    close () {
      this.$emit('updateStateShowForm', false)
    },
    clearElement (param) {
      this.model[param] = null
    }
  }
}
</script>

<template>
  <div class="showmodal card" v-if="showForm">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
    <div class="modalcontent ">
      <div class="components">
        <form action="">
          <div>
            <h5 class="card-header">{{schema.title}}</h5>
          </div>
          <div v-for="item in schema.fields" :key="item.id" class="form-group">
              <div class="col" v-if="item.type != 'select' && item.type != 'group' && item.type != 'password' ">
                <label class="labels-default" v-if="item.visible" :for="item.name">{{item.label}}</label>
                <input v-if="item.visible" class="form-control"
                  :type="item.inputType"
                  :name="item.name"
                  :placeholder="item.label"
                  :readonly="item.readonly"
                  v-model="model[item.model]"
                >
              </div>

              <div class="form-group" v-if="item.type === 'password'">
                <label class="labels-default" v-if="item.visible" :for="item.name">{{item.label}}</label>
                <div class="input-group">                    
                  <input v-if="item.visible"
                    id="input-pass"
                    class="form-control fa fa-eye"
                    :type="item.inputType"
                    :name="item.name"
                    :placeholder="item.label"
                    :readonly="item.readonly"
                    v-model="model[item.model]"
                  >
                  <div class="input-group-append">
                    <button
                      type="button"
                      class="input-group-text"                        
                      v-on:click="seePassword('input-pass')"
                    >
                      <i id="icon-input-pass" class="fa fa-eye"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div class="form-row" v-if="item.type === 'group'">
                <div class="input-group mb-6">
                  <div v-for="subitem in item.data" :key="subitem.id" for="item.group" class="col ajust-input">

                    <div v-if="subitem.inputType !== 'password'">
                      <label class="labels-default" v-if="subitem.visible" :for="item.name">{{subitem.label}}</label>
                      <input v-if="subitem.visible" class="form-control"
                        :type="subitem.inputType"
                        :name="subitem.name"
                        :placeholder="subitem.label"
                        :readonly="subitem.readonly"
                        :required="subitem.required"
                        v-model="model[subitem.model]"
                      >
                    </div>

                    <div v-if="subitem.inputType === 'password'">
                      <label class="labels-default" v-if="subitem.visible" :for="item.name">{{subitem.label}}</label>
                      <div class="input-group">                    
                        <input v-if="subitem.visible"
                          id="input-pass"
                          class="form-control fa fa-eye"
                          :type="subitem.inputType"
                          :name="subitem.name"
                          :placeholder="subitem.label"
                          :readonly="subitem.readonly"
                          v-model="model[subitem.model]"
                        >
                        <div class="input-group-append">
                          <button
                            type="button"
                            class="input-group-text"                        
                            v-on:click="seePassword('input-pass')"
                          >
                            <i id="icon-input-pass" class="fa fa-eye"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="col" v-if="item.type === 'select'">          
                <label class="labels-default" v-if="item.visible" for="item.name">{{item.label}}</label>
                <select
                  v-if="item.visible"
                  class="form-control"
                  :name="item.name"
                  v-model="model[item.model]"
                  v-on:keyup.8="clearElement(item.model)"
                  v-on:keyup.46="clearElement(item.model)"
                >
                  <option v-for="subitem in item.itens" :key="subitem.id" :value="subitem.value">
                    {{subitem.description}}
                  </option>
                </select>
              </div>
          </div>
          <div class="card-footer">
            <div class="text-right">
              <div class="buttons-dinamic">
                <input type="button"
                  value="Salvar"
                  class="btn bg-blue-dt btn-psq"
                  v-on:click="sendData(model)"
                >
                <input type="button"
                  value="Cancelar"
                  class="btn btn-danger btn-psq"
                  v-on:click="close"
                >
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<style scoped>
.showmodal {
  display: block;
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  overflow: auto;
  overflow-y: hidden;
  background-color: rgb(0,0,0);
  background-color: rgba(0,0,0,0.4);
}
.modalcontent {
  background-color: #fefefe;
  margin: 15% auto;
  margin-top: 20px;
  width: 80%;
  max-width: 800px;
  border-radius: 5px;
}
.components{height: 100%;}
.buttons-dinamic input{margin-left: 5px;}
.ajust-input{width: 100%}
.labels-default{margin-bottom: 3px; font-size: 14px}
</style>
